import { createFileRoute } from "@tanstack/react-router";
import { TransactionList } from "../../../features/transactions";

export const Route = createFileRoute("/_authed/transactions/")({
  component: Transactions,
});

function Transactions() {
  const { client } = Route.useRouteContext();
  return <TransactionList client={client} />;
}
